module.exports = __webpack_public_path__ + "static/media/[Professor_Teas]2014-03-30.de7d4284.md";